import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";
import equitrackThumbnail from "../../../../assets/img/caseStudies/EQMob2.webp";
import equitrackLogo from "../../../../assets/img/clients/equitrack.webp";

export default function Equitrack() {
    const caseStudy = new CaseStudyTemplate(
        "Equitrack",
        (
            <div>
                <p>
                    A comprehensive online equipment and asset management tool for tracking, inspecting, servicing and invoicing for movement of assets.  Integrating with other enterprise systems and interfacing with GPS Trackers, Bluetooth sensors and QR Coding.
                </p>
            </div>
        ),
        // Project Showcase Thumbnail
       
        equitrackThumbnail,
        new Company(
            "Equitrack",
            // Company Logo
            equitrackLogo
        ),
        "https://equitrack.co.uk/",
        [
            technologies.aspNET,
            technologies.telerik,
            technologies.azure,
            technologies.sqlServer
        ]
    )

    return (
        <CaseStudy caseStudy={caseStudy}></CaseStudy>
    )
}